module.exports = __webpack_public_path__ + "img/Novembro_Azul_1080x1080.ccd24153.jpg";